import React, { useEffect, useRef } from "react";
import { RotatingLines } from "react-loader-spinner";

const SmallLoader = ({ color }) => {
  return (
    <div className="mx-3" >
      <RotatingLines
        visible={true}
        height="30"
        width="30"
        strokeColor={color}
        strokeWidth="5"
        animationDuration="0.75"
        ariaLabel="rotating-lines-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </div>
  );
};

export default SmallLoader;
